import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{i18n "topic.slow_mode_update.title"}}
  class="edit-slow-mode-modal"
  @closeModal={{@closeModal}}
  @flash={{this.flash}}
>
  <:body>
    <div class="control-group">
      <label class="slow-mode-label">
        {{i18n "topic.slow_mode_update.description"}}
      </label>
    </div>
    <div class="control-group">
      <label class="slow-mode-label">
        {{i18n "topic.slow_mode_update.select"}}
      </label>
      <ComboBox
        class="slow-mode-type"
        @content={{this.slowModes}}
        @value={{this.selectedSlowMode}}
        @onChange={{this.setSlowModeDuration}}
      />
    </div>
    {{#if this.showCustomSelect}}
      <div class="control-group">
        <label class="slow-mode-label">
          {{i18n "topic.slow_mode_update.hours"}}
        </label>
        <Input @value={{this.hours}} @type="number" class="input-small" />
        <label class="slow-mode-label">
          {{i18n "topic.slow_mode_update.minutes"}}
        </label>
        <Input @value={{this.minutes}} @type="number" class="input-small" />
        <label class="slow-mode-label">
          {{i18n "topic.slow_mode_update.seconds"}}
        </label>
        <Input @value={{this.seconds}} @type="number" class="input-small" />
      </div>
    {{/if}}

    <div class="control-group">
      <FutureDateInput
        class="enabled-until"
        @label="topic.slow_mode_update.enabled_until"
        @labelClasses="slow-mode-label"
        @customShortcuts={{this.timeShortcuts}}
        @clearable={{true}}
        @input={{@model.topic.slow_mode_enabled_until}}
        @onChangeInput={{fn (mut @model.topic.slow_mode_enabled_until)}}
      />
    </div>
  </:body>
  <:footer>
    <DButton
      class="btn-primary"
      @disabled={{this.submitDisabled}}
      @icon="hourglass-start"
      @label={{this.saveButtonLabel}}
      @action={{this.enableSlowMode}}
    />
    {{#if @model.topic.slow_mode_seconds}}
      <DButton
        class="btn-danger"
        @action={{this.disableSlowMode}}
        @disabled={{this.submitDisabled}}
        @label="topic.slow_mode_update.remove"
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "kLmF2pbf",
  "block": "[[[8,[39,0],[[24,0,\"edit-slow-mode-modal\"]],[[\"@title\",\"@closeModal\",\"@flash\"],[[28,[37,1],[\"topic.slow_mode_update.title\"],null],[30,1],[30,0,[\"flash\"]]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"slow-mode-label\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"topic.slow_mode_update.description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"slow-mode-label\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"topic.slow_mode_update.select\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,2],[[24,0,\"slow-mode-type\"]],[[\"@content\",\"@value\",\"@onChange\"],[[30,0,[\"slowModes\"]],[30,0,[\"selectedSlowMode\"]],[30,0,[\"setSlowModeDuration\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"showCustomSelect\"]],[[[1,\"      \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"slow-mode-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"topic.slow_mode_update.hours\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,4],[[24,0,\"input-small\"]],[[\"@value\",\"@type\"],[[30,0,[\"hours\"]],\"number\"]],null],[1,\"\\n        \"],[10,\"label\"],[14,0,\"slow-mode-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"topic.slow_mode_update.minutes\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,4],[[24,0,\"input-small\"]],[[\"@value\",\"@type\"],[[30,0,[\"minutes\"]],\"number\"]],null],[1,\"\\n        \"],[10,\"label\"],[14,0,\"slow-mode-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"topic.slow_mode_update.seconds\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,4],[[24,0,\"input-small\"]],[[\"@value\",\"@type\"],[[30,0,[\"seconds\"]],\"number\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[8,[39,5],[[24,0,\"enabled-until\"]],[[\"@label\",\"@labelClasses\",\"@customShortcuts\",\"@clearable\",\"@input\",\"@onChangeInput\"],[\"topic.slow_mode_update.enabled_until\",\"slow-mode-label\",[30,0,[\"timeShortcuts\"]],true,[30,2,[\"topic\",\"slow_mode_enabled_until\"]],[28,[37,6],[[28,[37,7],[[30,2,[\"topic\",\"slow_mode_enabled_until\"]]],null]],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,8],[[24,0,\"btn-primary\"]],[[\"@disabled\",\"@icon\",\"@label\",\"@action\"],[[30,0,[\"submitDisabled\"]],\"hourglass-start\",[30,0,[\"saveButtonLabel\"]],[30,0,[\"enableSlowMode\"]]]],null],[1,\"\\n\"],[41,[30,2,[\"topic\",\"slow_mode_seconds\"]],[[[1,\"      \"],[8,[39,8],[[24,0,\"btn-danger\"]],[[\"@action\",\"@disabled\",\"@label\"],[[30,0,[\"disableSlowMode\"]],[30,0,[\"submitDisabled\"]],\"topic.slow_mode_update.remove\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\",\"@model\"],false,[\"d-modal\",\"i18n\",\"combo-box\",\"if\",\"input\",\"future-date-input\",\"fn\",\"mut\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/edit-slow-mode.hbs",
  "isStrictMode": false
});